import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import { languages } from '../i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = languages[i18n.language] || languages['en'];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
    
    // Update HTML lang attribute
    document.documentElement.lang = lng;
    
    // Update direction (for RTL languages like Arabic)
    document.documentElement.dir = languages[lng]?.dir || 'ltr';
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center space-x-2 text-[#3A312A] hover:text-[#B08D57] transition-colors"
        >
          <Globe size={18} />
          <span className="hidden md:inline text-sm font-medium">
            {currentLanguage.nativeName}
          </span>
          <span className="md:hidden text-sm">{currentLanguage.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent
        align="end"
        className="w-64 max-h-[400px] overflow-y-auto bg-white border border-[#E8DDD0] shadow-lg"
      >
        <div className="p-2">
          <p className="text-xs font-semibold text-[#3A312A]/60 px-2 py-1 mb-1">
            Select Language
          </p>
          {Object.entries(languages).map(([code, lang]) => (
            <DropdownMenuItem
              key={code}
              onClick={() => changeLanguage(code)}
              className="flex items-center justify-between px-3 py-2.5 cursor-pointer hover:bg-[#F6F1EA] rounded transition-colors"
            >
              <div className="flex items-center space-x-3">
                <span className="text-xl">{lang.flag}</span>
                <div>
                  <div className="text-sm font-medium text-[#3A312A]">
                    {lang.nativeName}
                  </div>
                  {lang.name !== lang.nativeName && (
                    <div className="text-xs text-[#3A312A]/60">
                      {lang.name}
                    </div>
                  )}
                </div>
              </div>
              {i18n.language === code && (
                <Check size={16} className="text-[#B08D57]" />
              )}
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
